<template>
    <div>
        <PageTitle :title="$t('perfil.titulo')" sectionClass="strech"/>
        <section class="padding-vertical-content">
            <div class="container">
                <ContentOrLoading>
                    <TabsComponent
                        :tabs="[
                            {tab : 'datos', nombre: $t('perfil.datos_personales')},
                            {tab : 'abonos', nombre: $t('perfil.abonos', {abonos: teatro.texto_abonos})},
                            {tab : 'pedidos', nombre: $t('perfil.pedidos')},
                            {tab : 'monedero', nombre: $t('perfil.saldo')},
                            {tab : 'info_pago', nombre: $t('perfil.info_pago')},                            
                            {tab : 'cantera', nombre: $t('perfil.cantera')},
                            {tab : 'parcelas', nombre: $t('home.parcelas')},
                        ]"
                        :initialTab="goToPlazos ? 'cantera' : 'datos'"
                    >
                        <template v-if="perfil" slot="datos">
                            <DatosUsuario :userData="perfil"/>
                        </template>
                        <template slot="abonos">
                            <Abonos/>
                        </template>
                        <template slot="pedidos">
                            <Pedidos/>
                        </template>
                        <template slot="cantera">
                            <PlazosCantera />
                        </template>
                        <template slot="monedero">
                            <Monedero/>
                        </template>
                        <template slot="info_pago">
                            <InformacionPagoPerfil
                                v-if="perfil && perfil.info_pago"
                                :tid="configuracion.hash_teatro"
                                :user_id="perfil?.id"
                                :nueva_alta="nueva_alta"
                            />
                            <div class="text-center" v-else>
                                <h3>{{ $t('perfil.no_info_pago') }}</h3>
                                <b-btn @click="showModal('editarInfo')">{{ $t('perfil.añadir_tarjeta') }}</b-btn>
                                <ActualizarInfoPagoModal :tid="configuracion.hash_teatro" :user_id="perfil?.id" :nueva_alta="nueva_alta" @close="closeModal('editarInfo')" />
                            </div>
                        </template>
                        <template slot="parcelas">
                            <Parcelas/>
                        </template>
                    </TabsComponent>
                </ContentOrLoading>
            </div>
        </section>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import TabsComponent from '@/components/frontend/components/TabsComponent';
    import DatosUsuario from '@/components/frontend/perfil/DatosUsuario';
    import Abonos from '@/components/frontend/perfil/Abonos';
    import Pedidos from '@/components/frontend/perfil/Pedidos';
    import Monedero from '@/components/frontend/perfil/Monedero';
    import InformacionPagoPerfil from '@/components/frontend/perfil/InformacionPagoPerfil';
    import PlazosCantera from '@/components/frontend/perfil/plazos/PlazosCantera';
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import ActualizarInfoPagoModal from '@/components/frontend/perfil/ActualizarInfoPagoModal';
    import Parcelas from '@/components/frontend/perfil/Parcelas';

    export default {
        data() {
            return {
                perfil: null
            }
        },
        head: {
            title: function() {
                return {
                    inner: 'Perfil',
                    complement: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title
                }
            },
            meta: function() {
                return [
                    {name: 'application-name', content: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title + ' - Venta Oficial de entradas'},
                    {name: 'description', content: this.teatro.meta_description ? this.teatro.meta_description : 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada', id: 'desc'}
                ]                
            },
        },
        created() {
            if(!this.isLogged){
                this.$router.push({name: 'login'});
            }
            this.getPerfil();
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            goToPlazos() {
                if (window.location.search.includes('error_plazos')) {
                    return true;
                } else {
                    return false;
                }
            },
            isLogged() {
                return this.$store.getters.isLogged;
            },
            nueva_alta() {
                return this.perfil && this.perfil.info_pago ? false : true;
            }
        },
        methods: {
            getPerfil() {
                const data = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    tid : this.configuracion.hash_teatro
                }
            
                this.$store.dispatch(this.config.getVuexAlias('front.perfil.get'), data).then(res => {
                    this.perfil = res.data.datos;
                });
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.getPerfil();
                this.$modal.hide(modal);
            }
        },
        components: {
            PageTitle, TabsComponent, DatosUsuario, Abonos, ContentOrLoading, Pedidos, Monedero, InformacionPagoPerfil, PlazosCantera, ActualizarInfoPagoModal, Parcelas
        }
    }
</script>
